const template = require('./edit-cell-alignment.hbs');

module.exports = Backbone.View.extend({
  events: {
    'click div:not(.table-cell-alignment-form)': 'applyEvent'
  },

  // Apply settings from UI to the current table
  applyEvent: function (event) {
    /*
    Get the desired position, for example 'ts' (top start)
    Vertical
        t: top
        c: center
        b: bottom

    Horizontal
        s: start (left for LTR and right for RTL)
        m: middle
        e: end (right for LTR and left for RTL)
    */
    const data = event.target.getAttribute('data-position');
    if (!data || data.length !== 2) return;

    let horizontal = 'middle';
    let vertical = 'center';

    switch (data[0]) {
      case 't':
        vertical = 'top';
        break;
      case 'b':
        vertical = 'bottom';
        break;
    }

    switch (data[1]) {
      case 's':
        horizontal = 'start';
        break;
      case 'e':
        horizontal = 'end';
        break;
    }

    const alignmentData = {
      horizontal,
      vertical
    };

    // INKIVE.Table.setTextAlignment(horizontal, vertical);
    INKIVE.DesignFacade.set({
      cell_alignment: alignmentData
    });
  },

  initialize: function (options) {
    this.element = options.selectedElement;
    this.render();
  },

  render: function () {
    this.$el.html(template({}));
  }
});
